let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToHash = (hash) => {
  const target = hash === "#top" ? 0 : document.querySelector(hash);
  if (target === null) return;
  if (lenisInstance) lenisInstance.scrollTo(target, { offset: -72, duration: 1.4 });
  else if (target === 0) window.scrollTo({ top: 0, behavior: "smooth" });
  else target.scrollIntoView({ behavior: "smooth" });
};

export const goToEstimate = (prefill) => {
  if (prefill) window.dispatchEvent(new CustomEvent("ks:prefill", { detail: prefill }));
  scrollToHash("#estimate");
};
